module.exports = __webpack_public_path__ + "static/media/deductibleK.d97fc5ea.svg";